import { IncentivesMarketBeneficiary } from 'modules/incentivesMarket/types';

export type IncentivesMarketPartyLike =
  | string
  | Pick<IncentivesMarketBeneficiary, 'name' | 'image'>;

export const getIncentivesMarketPartyName = (
  party: IncentivesMarketPartyLike
): string => {
  if (typeof party === 'string') return '-';
  return party?.name || '-';
};

export const getIncentivesMarketPartyImage = (
  party: IncentivesMarketPartyLike
): string => {
  if (typeof party === 'string') return '';
  return party?.image || '';
};

export const getIncentivesMarketPartyInitials = (
  party: IncentivesMarketPartyLike
): string => {
  const name = getIncentivesMarketPartyName(party);
  if (name === '-') return '-';

  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};
